import { useQuery } from '@tanstack/react-query';
import type { CompanyChecksResponse } from '@codepass/shared';
import { api } from '@/lib/api';

/**
 * The company check for every customer - Status on /kunder and the badge on /kunder/:id.
 *
 * One query for both pages, so moving between them reuses the answer. Keyed under 'customers'
 * so the Opdater button on /kunder refreshes it with the list. The server caches its sources
 * (the CVR register for a week, annual reports for a day), so a refresh is cheap.
 */
export function useCompanyChecks() {
  return useQuery({
    queryKey: ['customers', 'company-checks'],
    queryFn: () => api.get<CompanyChecksResponse>('/company-checks'),
    staleTime: 5 * 60_000,
  });
}
